import type {IndexCard} from '../../../../../schemas/contentful/contentTypes/indexTemplate'
import {ContentfulCard} from '../../../../../components/contentful/ContentfulCard/ContentfulCard'
import styles from './IndexCard.module.css'
import {clsx} from 'clsx'
import {getFallbackImageUrl} from '../../../utils/fallback-images'

type IndexCardProps = {
  component: IndexCard
  className?: string
  index?: number
  colorMode?: 'light' | 'dark'
}

export function IndexCard({component, className, index, colorMode}: IndexCardProps) {
  const {card} = component.fields

  // Default image to use if the card does not have an image.
  const defaultImage = {
    fields: {
      file: {
        url: getFallbackImageUrl(index ?? 0, colorMode),
      },
      description: '',
    },
  }

  const indexCard = card
    ? {
        ...card,
        fields: {
          ...card.fields,
          image: card.fields.image || defaultImage,
        },
      }
    : undefined

  return indexCard ? (
    <ContentfulCard component={indexCard} className={clsx(styles.indexCard, className)} fullWidth />
  ) : null
}
